/**
 * Web Style Import
 *
 */

import './dnb-skeleton.scss'
